// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__kxUJb","content":"RecentSearches_content__1C86-"};